var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcWickAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#273d3b;}.cls-2{fill:#395b56;}.cls-3{fill:#999;}.cls-4{fill:#e2e2e2;}.cls-5{fill:#1e1e1e;}.cls-6{fill:#4c4c4c;}.cls-7{fill:#6d6d6d;}.cls-8{fill:#7fdbc9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.21 205.47 138.99 173.19 228.22 205.47 210.2 245.36 138.72 276.02 67.23 245.36 49.21 205.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "262.98 280.23 14.46 280.23 39.48 224.84 138.72 174.81 237.96 224.84 262.98 280.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.06 258.2 138.99 274.34 97.37 258.2 86.61 202.21 190.82 202.21 180.06 258.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "247.76 185.29 138.72 224.42 29.67 185.29 37.28 118.52 98.42 65.02 138.72 60.11 180.94 66.48 241.19 119.56 247.76 185.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "92.82 208.04 43.25 189.87 43.25 165.66 80.6 112.96 138.98 96.67 166.81 145.54 92.82 208.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "186.23 208.17 235.8 189.99 235.8 165.79 198.45 113.09 140.07 96.8 112.24 145.67 186.23 208.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.67 136.67 153.41 123.76 139.23 138.29 124.46 123.17 78.21 136.08 53.47 170.5 47.01 191.48 104.03 213.53 138.69 176.45 173.85 214.12 230.87 191.53 224.41 171.09 199.67 136.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "181.19 213.28 138.76 224.27 96.34 213.28 105.03 180.88 138.76 165.59 172.95 181.34 181.19 213.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "147.59 119.18 138.99 165.66 130.38 119.18 128.77 66.69 139.25 60.24 149.21 66.69 147.59 119.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.78 218.33 138.72 221.6 124.66 218.33 123.5 200.17 139 193.63 153.94 200.17 152.78 218.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "225.22 123.98 168.12 66.88 220.13 15.11 239.91 31.59 225.22 123.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "218.76 111.24 179.19 71.67 215.24 35.79 228.94 47.21 218.76 111.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "49.76 125.19 106.97 67.97 54.86 16.1 35.04 32.61 49.76 125.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "56.23 112.42 95.88 72.77 59.76 36.83 46.03 48.27 56.23 112.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "149.86 163.21 178.26 167.81 200.35 151.89 165.73 144.69 149.86 163.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "128.11 163.21 99.72 167.81 77.62 151.89 112.24 144.69 128.11 163.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "250 165.37 258.75 86.82 247.59 77.02 234.7 84.14 225.94 162.69 236.95 172.47 250 165.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "246.32 129.17 255.15 49.94 251.04 44.01 245.79 48.9 236.96 128.13 241.01 134.06 246.32 129.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25 165.37 16.25 86.82 27.41 77.02 40.3 84.14 49.06 162.69 38.05 172.47 25 165.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "28.63 131.32 19.8 52.16 24.2 46.2 29.75 51.05 38.57 130.22 34.23 136.17 28.63 131.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.84 224.5 50.92 219.37 64.5 280.5 15.08 280.5 39.84 224.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "237.14 224.5 226.06 219.37 212.48 280.5 261.9 280.5 237.14 224.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcWickAvatar);
export default __webpack_public_path__ + "static/media/npc-wick-avatar.3bb866742eb8f7d4f9fec7330c0b7346.svg";
export { ForwardRef as ReactComponent };